import { FC } from "react";
import { Box, Skeleton, Stack } from "@mui/material";
import { background, divider } from "@/theme/colors";
import { rounded, spacing } from "@/theme/variables";

export const LearningProgressSkeleton: FC = () => {
  return (
    <Stack
      sx={{
        borderRadius: rounded.xs,
        border: `1px solid ${divider.high}`,
        bgcolor: background.white,
        p: spacing.sm,
        gap: spacing.mds,
      }}
    >
      <Stack gap={spacing.xs}>
        <Box display="flex" alignItems="center" gap={spacing.xxs}>
          <Skeleton variant="circular" width={24} height={24} />
          <Skeleton variant="text" width={120} height={24} />
        </Box>
        <Skeleton variant="rectangular" height={1} />
      </Stack>

      <Skeleton variant="rounded" height={32} sx={{ borderRadius: rounded.xs }} />

      {[0, 1].map((i) => (
        <Skeleton key={i} variant="rounded" height={60} sx={{ borderRadius: rounded.xs }} />
      ))}
    </Stack>
  );
};
